const {
	prepareFacets,
} = require('public/js/components/search-facets');

const {
	prepareFilters,
} = require('public/js/components/search-filters');

const {
	prepareSearchResults,
	category,
} = require('public/js/search-helper');
const { prepareCatalog } = require('../../../js/catalog-helper');
const utils = require('public/js/helpers/utils');
const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');

/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/

	(function SearchListingModule() {
		$onReady({
			rp$, window,
			label: 'search_listing',
			fn: function () {
				function numberWithCommas(x) {
					return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}

				function resultCountTween($el, start, end, decrement) {
					let step = 9;
					let diff = Math.abs(start - end);

					if (start === end) {
						$el.text(numberWithCommas(end));
						return; // Do nothing
					}

					if (decrement === true && start <= end) {
						$el.text(numberWithCommas(end));
						return;
					} else if (decrement === false && start >= end) {
						$el.text(numberWithCommas(end));
						return;
					}

					if (diff > 100) {
						step = Math.round((diff / 100) * 9);
					}

					start = (decrement === true) ? start - step : start + step;

					$el.text(numberWithCommas(start));

					if (start !== end) {
						setTimeout(function () {
							resultCountTween($el, start, end, decrement);
						}, 1);
					}
				}

				function handleNewCount($countEle, newCount) {
					var start = parseInt($countEle.text().toString().replace(/[^\d]/g,''), 10) || 0;
					var end = parseInt(newCount.toString().replace(/[^\d]/g,''), 10) || 0;
					var decrement = (start > end) ? true : false;
					resultCountTween($countEle, start, end, decrement);
				}

				rp$('.search-listing-module').parent().on('click', '.catalog-info-show-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					var fullInfo = rp$(this).data('full-info');
					rp$(this).parent().html(fullInfo);
				});
				if(window.tracking.google.use_gtag_admind_analytics){
					rp$('.product-title').on('click', 'a', function HookProductTitleClick(evt) {
						const product = utils.productTitleEvent( rp$(this).parent().parent() , rp$('.subcategory.active-cat')[0], 'Search');
						window.rp_app.track.track_ec_general('select_item', {
							currency:window.rp_app.cart._currency_code,
							items:utils.convertNamesOfItemsForGA([product])
						});
					});
				}

				rp$('.search-listing-module').parent().on('click', '.fitment-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					const elementsWithHideClass = rp$(this).parent().find('.hide');
					const elementsWithShowClass = rp$(this).parent().find('.show');
					elementsWithHideClass.addClass('show');
					elementsWithHideClass.removeClass('hide');
					elementsWithShowClass.addClass('hide');
					elementsWithShowClass.removeClass('show');
					rp$(this).addClass('hide');
				});

				rp$('.search-listing-module').parent().on('click', '.pagination-link', function HookPaginationClick(evt) {
					evt.preventDefault();

					var page = rp$(this).data('page');
					rp$(document).trigger('searchResults:pageChange', page);

					// Scroll to top of results
					rp$('html, body').animate({ scrollTop: 0 }, 'slow');
				});

				/* Handle Search Results Request
				.*-----------------------------------------*/
				function HandleSearchResultsRequest(evt) {
					partTypeFilterHelpers.showSpinner();
				}
				rp$(document).off('searchResults:request', HandleSearchResultsRequest);
				rp$(document).on('searchResults:request', HandleSearchResultsRequest);

				/* Handle Search Results Error
				.*-----------------------------------------*/
				function HandleSearchResultsError(evt) {
					rp$('.search-listing-module').overlaySpinner.remove();
					rp_app.notify.add_notification(javascriptContent.search_error, 'error');
				}
				rp$(document).off('searchResults:error', HandleSearchResultsError);
				rp$(document).on('searchResults:error', HandleSearchResultsError);

				/* Handle Search Results Response
				.*-----------------------------------------*/
				function HandleSearchResultsResponse(evt, response) {
					var $listingModule = rp$('.search-listing-module');
					$listingModule.overlaySpinner.remove();

					if(response.listings_html) {
						$listingModule.replaceWith(response.listings_html);
						if (typeof rp$.fn.add_to_cart === 'function') {
							rp$('.search-listing-module').find('.add-to-cart.enabled').add_to_cart();
						}
						if (typeof rp$.fn.product_quantity === 'function') {
							rp$('.search-listing-module').product_quantity();
						}
					}

					var $addMobile = rp$('.filters-overlay-content').find('.search-facets-module');
					var $addDesktop = rp$('.desktop-search-filters').find('.search-facets-module');

					if(response.mobile_facets) {
						$addMobile.replaceWith(response.mobile_facets);
					} else {
						$addMobile.find('.multi-select-facet-checkbox').prop("disabled", false);
					}

					if(response.desktop_facets) {
						$addDesktop.replaceWith(response.desktop_facets);
					} else {
						$addDesktop.find('.multi-select-facet-checkbox').prop("disabled", false);
					}

					if (response.use_cfc) {
						prepareCatalog();
					} else {
						prepareSearchResults(response.use_cfc);
					}
					prepareFacets();

					if(response.mobile_filters || response.desktop_filters) {
						var $addFiltersMobile = rp$('.filters-overlay-content').find('.vehicle-filters-module-container');
						var $addFiltersDesktop = rp$('.desktop-search-filters').find('.vehicle-filters-module-container');
						$addFiltersDesktop.replaceWith(response.desktop_filters);
						$addFiltersMobile.replaceWith(response.mobile_filters);
						prepareSearchResults();
						prepareFilters();
					}

					rp$('.result-count').each(function CountEle_Iterator(/*idx*/) {
						handleNewCount(rp$(this), response.count);
					});
					rp$('.result-ymm-text').html(response.ymm_text);
					rp$('.result-text').html(response.query);
					rp$('.search-bar-component input[type=text]').val(response.query);
				}
				rp$(document).off('searchResults:response', HandleSearchResultsResponse);
				rp$(document).on('searchResults:response', HandleSearchResultsResponse);
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
